import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import {
  FaqBuilder,
  InfoDropdown,
  InfoDropdownContent,
} from 'src/app/components/faq/faq.component';
import { FeatureType } from 'src/app/components/featured-plates/featured-plates.component';
import { PlatopediaPlate } from 'src/app/models/platopediaPlate';
import { Registration } from 'src/app/models/registration';
import { RegistrationService } from 'src/app/services/registration-service';
import { SearchService } from 'src/app/services/search-service';
import {
  PlatopediaFilter,
  PlatopediaSearchRequest,
} from '../platopedia-page/platopedia-page.component';
import { UserService } from 'src/app/services/user-service';
import SwiperCore, { Navigation, Thumbs, Pagination, Swiper } from 'swiper';
import {
  StickyConfig,
  StickyLink,
  StickyLinkGroup,
} from 'src/app/components/sticky-tabs/sticky-tabs.component';
import GlobalFaqs from "../../global-faqs";

SwiperCore.use([Navigation, Thumbs, Pagination]);

@Component({
  selector: 'name-plate-page',
  templateUrl: './name-plate-page.component.html',
  styleUrls: ['./name-plate-page.component.scss'],
})
export class NamePlatePageComponent implements OnInit {
  public stickyLinkConfig: StickyConfig = new StickyConfig(
    [
      new StickyLinkGroup(
        [
          new StickyLink('Names', 'names', true),
          new StickyLink('Market Insights', 'market-information', false),
          new StickyLink('Q&As', 'faq', false),
        ])],
    new EventEmitter<void>()
  );
  public alphabet: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  private alphabetResultMatrix: { letter: string, resultCount: number }[] = [];
  public currentAlphabet = 'A';
  public searchRequest: PlatopediaSearchRequest;
  private searchResults: Registration[] = [];
  public npFeatured = new FeatureType(
    'Most Expensive Names',
    'most-expensive-names'
  );
  public hideSold: boolean = false;
  public loading: boolean;
  public saving: boolean = false;
  public notifiying: boolean = false;

  public activeFilters: string[] = ['gb'];
  private lastSearchQuery: string;

  public faq: InfoDropdown[] = GlobalFaqs.GetFaqsByKey("Names");

  public flagFilters = [
    { iso: 'gb', filter: 'gb', name: 'UK', flag: 'great%20britain' },
    { iso: 'ae', filter: 'ae', name: 'UAE', flag: 'united%20arab%20emirates' },
    { iso: 'at', filter: 'at', name: 'Austria', flag: 'austria' },
    { iso: 'be', filter: 'be', name: 'Belgium', flag: 'belgium' },
    { iso: 'ch', filter: 'ch', name: 'Switzerland', flag: 'switzerland' },
    { iso: 'cn', filter: 'cn', name: 'China', flag: 'china' },
    { iso: 'de', filter: 'de', name: 'Germany', flag: 'germany' },
    { iso: 'dk', filter: 'dk', name: 'Denmark', flag: 'denmark' },
    { iso: 'es', filter: 'es', name: 'Spain', flag: 'spain' },
    { iso: 'fr', filter: 'fr', name: 'France', flag: 'france' },
    { iso: 'gr', filter: 'gr', name: 'Greece', flag: 'greece' },
    { iso: 'il', filter: 'il', name: 'Israel', flag: 'israel' },
    { iso: 'in', filter: 'in', name: 'India', flag: 'india' },
    { iso: 'is', filter: 'is', name: 'Iceland', flag: 'iceland' },
    { iso: 'it', filter: 'it', name: 'Italy', flag: 'italy' },
    { iso: 'jp', filter: 'jp', name: 'Japan', flag: 'japan' },
    { iso: 'kr', filter: 'kr', name: 'South Korea', flag: 'south%20korea' },
    { iso: 'kz', filter: 'kz', name: 'Kazakhstan', flag: 'kazakhstan' },
    { iso: 'lu', filter: 'lu', name: 'Luxembourg', flag: 'luxembourg' },
    { iso: 'mt', filter: 'mt', name: 'Malta', flag: 'malta' },
    { iso: 'nl', filter: 'nl', name: 'Netherlands', flag: 'netherlands' },
    { iso: 'no', filter: 'no', name: 'Norway', flag: 'norway' },
    { iso: 'pl', filter: 'pl', name: 'Poland', flag: 'poland' },
    { iso: 'pt', filter: 'pt', name: 'Portugal', flag: 'portugal' },
    { iso: 'ru', filter: 'ru', name: 'Russia', flag: 'russia' },
    { iso: 'se', filter: 'se', name: 'Sweden', flag: 'sweden' },
    { iso: 'tr', filter: 'tr', name: 'Turkey', flag: 'turkey' },
    { iso: 'ua', filter: 'ua', name: 'Ukraine', flag: 'ukraine' },
    { iso: 'vn', filter: 'vn', name: 'Vietnam', flag: 'vietnam' },
  ];

  public swiper: Swiper;
  public swiperNavigation = {
    nextEl: '.swiper-nav.swiper-next',
    prevEl: '.swiper-nav.swiper-prev',
  };
  public swiperBreakpoints = {
    1200: {
      slidesPerView: 5,
    },
    1100: {
      slidesPerView: 5,
    },
    900: {
      slidesPerView: 4,
    },
    850: {
      slidesPerView: 4,
    },
    700: {
      slidesPerView: 3,
    },
    550: {
      slidesPerView: 2,
    },
  };

  constructor(
    private searchService: SearchService,
    private registrationService: RegistrationService,
    private userService: UserService
  ) {
    this.searchRequest = new PlatopediaSearchRequest(
      'AZ',
      [new PlatopediaFilter('Names', 'name', true)],
      'A-Z',
      'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    );
    this.searchRequest.indiLetter = 'ALL';
    this.searchRequest.queryString = `?allFiltersRequired=false&filters=`;

    this.Search();
  }

  ngOnInit(): void { }

  public swiperInit(_e: any): void {
    this.swiper = _e[0];
  }

  public setAlphabet(letter: string): void {
    this.currentAlphabet = letter;
  }

  private CreateQueryString(): string {
    var queryString = this.searchRequest.queryString;
    if (this.activeFilters.length > 0)
      queryString += `${this.activeFilters.join(',')}`;
    else queryString += 'name';
    return queryString;
  }

  public Search(): void {
    const qs = this.CreateQueryString();
    if (this.lastSearchQuery != null) {
      if (this.lastSearchQuery == qs) return; // dont repeat search
    }
    this.lastSearchQuery = qs;
    this.loading = true;

    this.searchService.searchplatopedia(
      qs,
      (filters: string, _: PlatopediaPlate[]) => {
        if (filters !== this.CreateQueryString()) return;
        this.searchResults = this.registrationService.formatRegistrations(
          [..._].map((p: PlatopediaPlate) => {
            p.registration.meta_data = {
              term: p.word,
            };
            p.registration.term = p.word;
            return p.registration;
          })
        );

        this.loading = false;
        this.BuildResultMatrix();
      }
    );
  }

  public filterChange(open: boolean): void {
    if (!open) this.Search();
  }

  public toggleFilter(filter: string): void {
    this.activeFilters = [filter];
    try {
      navigator.vibrate(100);
    } catch (e: any) {
      console.log(e);
    }
    this.Search();
  }

  public updateQueryString(change: MatSelectChange): void {
    this.activeFilters = [...change.value];
  }

  public FilterActive(filter: string): boolean {
    return this.activeFilters.findIndex((f) => f == filter) > -1;
  }

  public FiltersUpdated(filter: string): void {
    const filterIndex = this.activeFilters.findIndex((f) => f == filter);
    if (filterIndex === -1) this.activeFilters.push(filter);
    else this.activeFilters.splice(filterIndex, 1);

    this.Search();
  }

  public BuildResultMatrix(): void {
    this.alphabetResultMatrix = [];
    this.alphabet.forEach((letter: string) => {
      const res = this.searchResults
        .filter((p) => p.term.startsWith(letter))
        .filter((p) => {
          if (this.hideSold && p.plateOwner == -1) return false;
          return true;
        });
      this.alphabetResultMatrix.push({ letter: letter, resultCount: res.length })
    });
  }

  public PlateCountForLetter(letter: string): number {
    const record = this.alphabetResultMatrix.find(x => x.letter == letter);
    if (record) return record.resultCount;
    return 0;
  }

  public PlatesForLetter(letter: string): Registration[] {
    if (this.searchResults === undefined || this.searchResults.length === 0)
      return [];
    this.loading = true;
    const res = this.searchResults
      .filter((p) => p.term.startsWith(letter))
      .filter((p) => {
        if (this.hideSold && p.plateOwner == -1) return false;
        return true;
      })
      .sort((a, b) => a.meta_data['term'].localeCompare(b.meta_data['term']));

    this.loading = false;
    return res;
  }

  public notifyRegistration(reg: Registration): void {
    if (this.notifiying) return;
    this.notifiying = true;
    reg.notify = !reg.notify; // UI update
    this.userService.notifyRegistrationString(
      reg.registration,
      (notifs: Registration[]) => {
        var _filteredNotifies = notifs.filter(
          (f) =>
            f.registration.replace(' ', '') == reg.registration.replace(' ', '')
        );
        reg.notify = _filteredNotifies && _filteredNotifies.length > 0;
        this.notifiying = false;
      }
    );
  }

  public favouriteRegistration(reg: Registration): void {
    if (this.saving) return;
    this.saving = true;
    reg.favourite = !reg.favourite; // UI update
    this.userService.favouriteRegistrationString(
      reg.registration,
      (favs: Registration[]) => {
        var _filteredFavourites = favs.filter(
          (f) =>
            f.registration.replace(' ', '') == reg.registration.replace(' ', '')
        );
        reg.favourite = _filteredFavourites && _filteredFavourites.length > 0;
        this.saving = false;
      }
    );
  }
}
